
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport05Dialog extends Serenity.EntityDialog<IcReport05Row, any> {
        protected getFormKey() { return IcReport05Form.formKey; }
        protected getIdProperty() { return IcReport05Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport05Row.localTextPrefix; }
        protected getNameProperty() { return IcReport05Row.nameProperty; }
        protected getService() { return IcReport05Service.baseUrl; }
        protected getDeletePermission() { return IcReport05Row.deletePermission; }
        protected getInsertPermission() { return IcReport05Row.insertPermission; }
        protected getUpdatePermission() { return IcReport05Row.updatePermission; }

        protected form = new IcReport05Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}